
export default function FileMobileModule(/* callback */) {
  //let callbacks = bindCallbacks(CONVERT_LIST, callback);
  let fragments = [
    // {
    //   // to remove 'file-properties' group which is in home tab
    //   action: ACTIONS.REMOVE,
    //   target: FILE_PROPERTIES_GROUP_IN_HOME,
    // },
    //...callbacks,
  ];
  return { fragments };
}
